export enum EErrorPageType {
  AccessDenied = 'ACCESS_DENIED',
  NotFound = 'PAGE_NOT_FOUND',
  ServerError = 'SERVER_ERROR',
}
